.wrap {
  min-width: 0;
}

.scroll {
  overflow-x: auto;
}

.grid {
  width: 100%;
  min-width: 520px;
  border-collapse: separate;
  border-spacing: 3px;
  table-layout: fixed;
  font-size: var(--t-min);
}

.corner {
  width: 150px;
}

.colHead {
  color: var(--muted);
  font-weight: 600;
  text-align: center;
}

.rowHead {
  overflow: hidden;
  padding-right: 6px;
  color: var(--ink);
  font-weight: 650;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rowLabel,
.rowSub {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rowSub {
  color: var(--muted);
  font-weight: 400;
}

.cellBox {
  padding: 0;
  border-radius: 5px;
}

.cellBox:focus-visible {
  outline: 2px solid var(--ink);
  outline-offset: 1px;
}

.cellBox:hover .hmCell {
  outline: 2px solid var(--ink);
  outline-offset: 1px;
}

/* A cell pops in once, staggered by its row and column (inline delay). */
.hmCell {
  display: block;
  height: 22px;
  border-radius: 5px;
  animation: cell-pop 0.35s var(--ease-out) both;
}

@keyframes cell-pop {
  from {
    opacity: 0;
    transform: scale(0.6);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .hmCell {
    animation: none;
  }
}

/* The six states. Each is a colour AND a pattern, so no state rests on hue alone. */
.s_received {
  background: var(--hm-received);
}

.s_declared_nil {
  background:
    linear-gradient(var(--ink-2), var(--ink-2)) center / 9px 2px no-repeat,
    var(--hm-nil);
}

.s_missing {
  background: repeating-linear-gradient(135deg, var(--hm-missing-stripe) 0 2px, transparent 2px 6px), var(--hm-missing);
}

.s_pending {
  background:
    radial-gradient(circle, var(--warn) 1px, transparent 1.6px) 0 0 / 6px 6px,
    var(--hm-pending);
}

.s_unknown {
  background: repeating-linear-gradient(45deg, var(--hm-unknown-a) 0 4px, var(--hm-unknown-b) 4px 8px);
}

.s_not_expected {
  border: 1px dashed var(--line-2);
  background: transparent;
}

.legend {
  margin: 10px 0 0;
}

.hmSwatch {
  display: inline-block;
  width: 14px;
  height: 12px;
  flex: 0 0 auto;
  border-radius: 3px;
}
